export const experienceData = [
  {
    role: "AI Engineer",
    company: "Areeb Technology",
    location: "Cairo, Egypt",
    duration: "Aug 2025 – Present",
    highlights: [
      "Architected 2 end-to-end AI automation pipelines using n8n, OpenAI, and Telegram, reducing manual content production time by approximately 90% for company blog operations.",
      "Built an AI-powered Applicant Tracking System (ATS) using LangChain, LangGraph, OpenAI, FastAPI, and Celery, cutting CV screening times with: automated assessment scoring, AI-generated personalized interview questions, semantic parsing using embeddings, and consistency validation flagging discrepancies with 90%+ accuracy.",
      "Developed 2 custom Model Context Protocol (MCP) servers enabling natural language control of Azure DevOps work items and Strapi CMS publishing—reducing task completion time for non-technical stakeholders by 90%.",
      "Guided software engineering teams in adopting AI-assisted development workflows using Cursor and GitHub Copilot, improving development productivity and code quality across internal projects.",
      "Mentored 6 AI interns on LLM application development, prompt engineering, and agent-based architectures.",
      "Collaborated with the design team to integrate Figma MCP into AI-assisted workflows, cutting design-system component creation time by approximately 95%."
    ]
  },
  {
    role: "Software Engineer",
    company: "Self-Employed",
    location: "Egypt",
    duration: "Nov 2021 – Dec 2022",
    highlights: [
      "Designed, developed, and published 3 mobile applications using Flutter targeting productivity and education verticals, achieving 1,000+ cumulative downloads across platforms.",
      "Built 3 interactive 3D and Augmented Reality applications in Unity, implementing real-time rendering pipelines and user interaction systems for immersive mobile experiences.",
      "Engineered 4+ full-stack web applications using HTML, CSS, JavaScript, PHP, and SQL, delivering responsive frontends backed by relational database systems."
    ]
  }
];
